import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GameDynamicBlockContainerDirective } from './game-dynamic-block-container.directive';
import { GameDynamicBlockDirective } from './game-dynamic-block.directive';
import { GameDynamicTemplateOutletDirective } from './game-dynamic-template-outlet.directive';



@NgModule({
  declarations: [
    GameDynamicBlockContainerDirective,
    GameDynamicBlockDirective,
    GameDynamicTemplateOutletDirective,
  ],
  exports: [
    GameDynamicBlockContainerDirective,
    GameDynamicBlockDirective,
    GameDynamicTemplateOutletDirective,
  ],
  imports: [
    CommonModule,
  ],
})
export class GameDynamicBlocksModule { }
